import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Params } from '../../pages/params';
import * as firebase from 'firebase/app';

/*
  Generated class for the RequestsExecutionProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class RequestsExecutionProvider {
  types = {}
  constructor(public http: Http) {
    this.types = Params.REQUEST_TYPES;
    console.log('Hello RequestsExecutionProvider Provider');
  }

  process(request):Promise<any>{
    return new Promise((resolve, reject) => {
      console.log("in promise",request);

      if(request.type=="CF"){
        let change = {foods : request.CF.foods};

        firebase.functions().httpsCallable('acFoods')({ email: request.customerData.email, foods_old: request.CF.old, foods_new: request.CF.foods })
          .then((res) => {
            console.log('res CF', res);
          }).catch((err) => {
            console.log('catch err CF', err);
          });

        firebase.database().ref('/customers/'+request.customer)
          .update(change).then(()=>{
          resolve(true);
        }).catch((e)=>{
          resolve(false);
        })
      }

      if(request.type=="CP"){
        console.log('request CP')
        let change = {foods : request.CP.foods,plan : request.CP.key};

        firebase.functions().httpsCallable('acPlans')({ email: request.customerData.email, plan_old: request.CP.old.plan, plan_new: request.CP.key })
          .then((res) => {
            console.log('res CP', res);
          }).catch((err) => {
            console.log('catch err CP', err);
          });

        
        firebase.database().ref('/customers/'+request.customer)
          .update(change).then(()=>{
          resolve(true);
        }).catch((e)=>{
          resolve(false);
        })
      }

      if(request.type=="CI1" || request.type=="CI2"){
        console.log('request CI')
        let change = {active : false};

        firebase.functions().httpsCallable('acStatus')({ email: request.customerData.email, change: change.active })
          .then((res) => {
            console.log('res CI', res);
          }).catch((err) => {
            console.log('catch err CI', err);
          });

        firebase.database().ref('/customers/'+request.customer)
          .update(change).then(()=>{
          resolve(true);
        }).catch((e)=>{
          resolve(false);
        })
      }

      if(request.type=="RE"){
        console.log('request RE')
        let change = {active : true};

        firebase.functions().httpsCallable('acStatus')({ email: request.customerData.email, change: change.active })
          .then((res) => {
            console.log('res RE', res);
          }).catch((err) => {
            console.log('catch err RE', err);
          });

        firebase.database().ref('/customers/'+request.customer)
          .update(change).then(()=>{
          resolve(true);
        }).catch((e)=>{
          resolve(false);
        })
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/requests-execution/requests-execution.ts